import ContentfulApi from "utils/ContentfulApi";
import { Config } from "utils/Config";
import FullPage from "components/FullPage";
import { parentTags, domainSlugs } from "utils/tagsData";
import cleanDataAndAdditionalData from "utils/cleanDataAndAdditionalData";

export default function ArticlesPaginatedPage(props) {
	let { data, err, additionalData } = props;

	const fields = data?.items[0]?.fields;
	return (
		<>
			{!fields && `No fields for Articles Landing Page`}
			<FullPage pageData={data} additionalData={additionalData} noindex={true} />
		</>
	);
}

export async function getStaticPaths() {
	const paths = [];
	await Promise.all(
		Object.values(domainSlugs).map(async (domain, index) => {
			const domainSlug = Object.keys(domainSlugs)[index];

			const totalArticles = await ContentfulApi.getTotalArticles({ domain });
			const totalPages = Math.ceil(totalArticles / Config.pagination.pageSize);

			/**
			 * Start from page 2, so we don't replicate /articles
			 * which is page 1
			 */
			for (let page = 1; page <= totalPages; page++) {
				paths.push({ params: { topic: domainSlug, page: page.toString() } });
			}

			// return { params: { topic: topicSlug } };
		})
	);

	return {
		paths,
		fallback: "blocking",
	};
}

export async function getStaticProps({ params }) {
	let _data = await ContentfulApi.getPage("Articles Landing Page");
	const { data, additionalData } = await cleanDataAndAdditionalData({ pageData: _data, pageParams: params });

	//additional data should have productCollection items, if not, return 404 notFound
	if (!additionalData.productCollection.items.length) {
		return {
			notFound: true,
			...(process.env.REVALIDATE_TIMER && { revalidate: process.env.REVALIDATE_TIMER }),
		};
	}

	return {
		props: {
			data, //contentful page data
			additionalData, //: { productCollection: productCollection, totalPages, currentPage: page },
		},
		...(process.env.REVALIDATE_TIMER && { revalidate: process.env.REVALIDATE_TIMER }),
	};
}
